import EntityDetailsMobile from '@/agilis/mobile/EntityDetailsMobile/EntityDetailsMobile.vue'
import TrackerDataTableItemChildrenMobile from '@/agilis/mobile/TrackerDataTableItemChildrenMobile/TrackerDataTableItemChildrenMobile.vue'
import TrackerDataTableItemActionsMobile from '@/agilis/mobile/TrackerDataTableItemActionsMobile/TrackerDataTableItemActionsMobile.vue'
import TrackerDataTableItemCollaboratorsMobile
from '@/agilis/mobile/TrackerDataTableItemCollaboratorsMobile/TrackerDataTableItemCollaboratorsMobile.vue'
import TrackerDataTableItemAssociationsMobile
from '@/agilis/mobile/TrackerDataTableItemAssociationsMobile/TrackerDataTableItemAssociationsMobile.vue'
import FileUploaderMobile from '@/agilis/mobile/FileUploaderMobile/FileUploaderMobile.vue'
import TrackerDataTableItemNotesMobile
from '@/agilis/mobile/TrackerDataTableItemNotesMobile/TrackerDataTableItemNotesMobile.vue'
import TrackerHistoryMobile from '@/agilis/mobile/TrackerHistoryMobile/TrackerHistoryMobile.vue'
import WorkPackage from '@/applications/sales/components/WorkPackage/WorkPackage.vue'
import WorkPackageV3 from '@/applications/sales/components/WorkPackageV3/WorkPackageV3.vue'
import WorkPackageV3Mobile from '@/applications/sales/mobile/WorkPackageV3Mobile/WorkPackageV3Mobile.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ComponentResolverTrackerDataTableMobile',

  props: {
    componentId: String,
    forwardRef: Function,
    componentProps: {
      type: Object,
      default: () => ({})
    }
  },

  components: {
    EntityDetailsMobile,
    FileUploaderMobile,
    TrackerDataTableItemChildrenMobile,
    TrackerDataTableItemActionsMobile,
    TrackerDataTableItemCollaboratorsMobile,
    TrackerDataTableItemAssociationsMobile,
    TrackerDataTableItemNotesMobile,
    TrackerHistoryMobile,
    WorkPackage,
    WorkPackageV3,
    WorkPackageV3Mobile
  },

  data: () => ({
    resolvedComponentId: ''
  }),

  created: function () {
    this.resolvedComponentId = this.resolveMobileComponent()
  },

  mounted: function () {
    if (typeof this.forwardRef === 'function') {
      this.forwardRef(this.$refs.componentResolved)
    }
  },

  methods: {
    /**
     * Finds and returns the mobile component associated to the component id
     */
    resolveMobileComponent () {
      return this.componentId
    }
  },
  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId'
    }),
    forwardProps () {
      return {
        ...this.componentProps
      } // add here props that need to be forwarded to the final component
    }
  }
}
